import { render, staticRenderFns } from "./profile-company-flow.vue?vue&type=template&id=1ed14762&scoped=true"
import script from "./profile-company-flow.vue?vue&type=script&lang=js"
export * from "./profile-company-flow.vue?vue&type=script&lang=js"
import style0 from "./profile-company-flow.vue?vue&type=style&index=0&id=1ed14762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed14762",
  null
  
)

export default component.exports